const x = 2147483648;
const baseId =
	Math.floor(Math.random() * x).toString(36) +
	Math.abs(Math.floor(Math.random() * x) ^ Date.now()).toString(36);

let count = 0;
export default function guid() {
	count = count + 1;
	return `${baseId}-${count}`;
}
